<div class="modal-header">
  <h4 class="modal-title" i18n>Aggiungi Sitemap</h4>
  <button type="button" class="btn-close" i18n-aria-label aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"></button>
</div>
<form [formGroup]="sitemapForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="mb-3">
      <label for="sitemaps" class="form-label">Inserisci uno o più URL di sitemap per facilitare e velocizzare
        l'indicizzazione di siti web che hai inserito. <br />
        Ogni sitemap deve essere accessibile pubblicamente e conforme allo standard XML. <br />
      </label>
      <textarea class="form-control" id="sitemaps" formControlName="sitemaps" rows="5" placeholder="https://example.com/sitemap.xml
https://another-example.com/sitemap-2.xml"></textarea>
      <div id="sitemapsHelp" class="form-text" i18n>
        Puoi aggiungere più sitemap incollando una URL per ogni riga.
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-loading-button [loading]="loading" [disabled]="loading" i18n>Conferma</app-loading-button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()" i18n>Annulla</button>
  </div>
</form>